// extracted by mini-css-extract-plugin
export default {"image-section":"Syvi_image-section__kE821","overlay":"Syvi_overlay__jThWC","image-container":"Syvi_image-container__HAKB8","logo":"Syvi_logo__JVsPZ","text":"Syvi_text__AmpC9"};